import { EvaluationMonth } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/models';

/**
 * The evaluation period directly after `month`, rolling over into the next year in December.
 * `EvaluationMonth.month` is 1-based, so this cannot be a plain `month + 1`.
 */
export function getNextMonth({ year, month }: EvaluationMonth): EvaluationMonth {
  return month === 12 ? { year: year + 1, month: 1 } : { year, month: month + 1 };
}
